import { Button } from '@mui/material';
import { useContext } from '../../context.jsx';
import { useDeleteContext } from './delete-context.jsx';

export function DeleteButton() {
  const { setConfirming } = useDeleteContext();
  const { tab, getSelectedInstances } = useContext();
  const instances = getSelectedInstances();

  return tab !== 'instances' ? null : (
    <Button disabled={!instances?.length} onClick={() => setConfirming(true)}>
      Delete Instance
    </Button>
  );
}
